import { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

const SidebarContext = createContext()

export function SidebarProvider({ children, setIsSidebarVisible, isSidebarVisible }) {
  const value = useMemo(() => ({ setIsSidebarVisible, isSidebarVisible }), [setIsSidebarVisible, isSidebarVisible])
  return <SidebarContext.Provider value={value}>
    {children}
  </SidebarContext.Provider>
}

SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired,
  setIsSidebarVisible: PropTypes.func.isRequired,
  isSidebarVisible: PropTypes.bool.isRequired,
}

export const useSidebar = () => useContext(SidebarContext)
